import React from "react";
import {
  ISelectInput,
  ISelectOption,
} from "Interfaces/interface.mockupGenerator";

const SelectInput: React.FC<ISelectInput> = ({
  label,
  value,
  onChange,
  options,
  icon: Icon,
}) => (
  <div className="space-y-2">
    <div className="flex items-center gap-2">
      {Icon && <Icon className="w-4 h-4 text-gray-600" />}
      <label className="text-sm font-semibold text-gray-700">{label}</label>
    </div>
    <select
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-400 bg-white shadow-sm transition-all"
    >
      {options.map((option: ISelectOption) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  </div>
);

export default SelectInput;
